import { CalendarIcon } from "@phosphor-icons/react/dist/csr/Calendar";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { getAddressString } from "@/core/utils/address";
import { formatTime } from "@/core/utils/date";
import { CardBand } from "./card-band";
import InfoPair from "./info-pair";
import { NameAndDate, NameAndDateSkeleton } from "./name-and-date";
import type { ReferralContentProps } from "./referralContent";

export const ScheduledReferralCardSkeleton = () => (
  <Stack className="w-full" align="start" gap={0}>
    <CardBand>
      <Skeleton className="h-4 w-4" />
      <Skeleton className="h-4 w-24" />
    </CardBand>
    <Stack align="start" gap={4} className="w-full p-4">
      <NameAndDateSkeleton />
      <Stack align="start" gap={2}>
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-4 w-48" />
      </Stack>
    </Stack>
  </Stack>
);

export const ScheduledReferralCardContent = ({
  referral,
  onLost,
  onMoveToPaid,
  onDelete,
}: ReferralContentProps) => (
  <Stack className="w-full" align="start" gap={0}>
    <CardBand>
      <CalendarIcon aria-hidden="true" />
      <Text variant="caption">
        {referral.appointment_date
          ? formatTime(referral.appointment_date)
          : "No appointment date"}
      </Text>
    </CardBand>
    <Stack align="start" gap={4} className="w-full p-4">
      <NameAndDate
        referral={referral}
        hideDate
        onLost={onLost}
        onMoveToPaid={onMoveToPaid}
        onDelete={onDelete}
      />
      <Stack align="start" gap={2}>
        <InfoPair label="Services" info={referral.service_needed} />
        <InfoPair label="Address" info={getAddressString(referral.address)} />
      </Stack>
    </Stack>
  </Stack>
);
